import { StoryblokComponent, storyblokEditable } from "@storyblok/react";

const HeaderBlockLanding = ({ blok }) => {
  console.log(blok.form)
  return (
    <div {...storyblokEditable(blok)} className="block-image">
      <div className="container herosub" id="form">
        <div className="landing-header-grid">
          <div className="landing-header-grid-left">
          
            <h2>{blok.title}</h2>
            <h3>{blok.subtitle}</h3>
            <p>{blok.introtext}</p>
          </div>
          <div className="landing-header-grid-right">
            
            <StoryblokComponent blok={blok.form[0]} />
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderBlockLanding;
